import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WithUser } from "common-frontend-components";
// import {PhotosList} from "../../components/Photos/PhotosList";
import { Grid } from "@mui/material";
// import {CategoryManager} from "../../components/categories/CategoryManager";
import { PostManager } from "../../components/entities/posts/post/PostManager";
// import {PostCategoryAssociationManager} from "../../components/postCategoryAssociations/PostCategoryAssociationManager";
import { pageStyle } from "../../assets/styles/styles";
import { ImageFullViewPopup } from "../../components/popups/ImageFullView";
import { ProductFullViewPopup } from "../../components/popups/ProductFullView";
import { useOnLazyPageLoad } from "../../hooks/useOnAppLoad";
// example for monorepo react module
// import {Popcorn} from "@common/client";
export const AdminHomePage = WithUser(() => {
    useOnLazyPageLoad();
    return (
    // example for monorepo react module
    // <Popcorn/>
    _jsxs(Grid, { container: true, spacing: 2, sx: pageStyle, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(PostManager, {}, void 0) }, void 0), _jsx(ImageFullViewPopup, {}, void 0), _jsx(ProductFullViewPopup, {}, void 0)] }, void 0));
});
//# sourceMappingURL=AdminHomePage.js.map